import { render } from "./NotificationSchedules.vue?vue&type=template&id=ad9b584c&scoped=true"
import script from "./NotificationSchedules.vue?vue&type=script&lang=js"
export * from "./NotificationSchedules.vue?vue&type=script&lang=js"

import "./NotificationSchedules.vue?vue&type=style&index=0&id=ad9b584c&lang=scss&scoped=true"

import exportComponent from "/app/src/client/.yarn/__virtual__/vue-loader-virtual-e12e5a5897/0/cache/vue-loader-npm-17.0.1-f552b82805-b10a7b05ba.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad9b584c"]])

export default __exports__